import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Table as SpTable } from './index.js';
import { TableBody as SpTableBody } from './index.js';
import { TableCell as SpTableCell } from './index.js';
import { TableCheckboxCell as SpTableCheckboxCell } from './index.js';
import { TableHead as SpTableHead } from './index.js';
import { TableHeadCell as SpTableHeadCell } from './index.js';
import { TableRow as SpTableRow } from './index.js';

export const Table = dynamic<
    JSX.LibraryManagedAttributes<typeof SpTable, ComponentProps<typeof SpTable>>
>(() => import('./index.js').then(({ Table }) => Table), { ssr: false });
export const TableBody = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableBody,
        ComponentProps<typeof SpTableBody>
    >
>(() => import('./index.js').then(({ TableBody }) => TableBody), {
    ssr: false,
});
export const TableCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCell,
        ComponentProps<typeof SpTableCell>
    >
>(() => import('./index.js').then(({ TableCell }) => TableCell), {
    ssr: false,
});
export const TableCheckboxCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCheckboxCell,
        ComponentProps<typeof SpTableCheckboxCell>
    >
>(
    () =>
        import('./index.js').then(({ TableCheckboxCell }) => TableCheckboxCell),
    { ssr: false }
);
export const TableHead = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHead,
        ComponentProps<typeof SpTableHead>
    >
>(() => import('./index.js').then(({ TableHead }) => TableHead), {
    ssr: false,
});
export const TableHeadCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHeadCell,
        ComponentProps<typeof SpTableHeadCell>
    >
>(() => import('./index.js').then(({ TableHeadCell }) => TableHeadCell), {
    ssr: false,
});
export const TableRow = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableRow,
        ComponentProps<typeof SpTableRow>
    >
>(() => import('./index.js').then(({ TableRow }) => TableRow), { ssr: false });
